import { Phone, MessageCircle, Instagram, MapPin } from "lucide-react";
import { PHONE_1, PHONE_1_TEL, PHONE_2, INSTAGRAM_URL, INSTAGRAM_HANDLE, waLink, WA_DEFAULT, scrollToId } from "@/data/site";

const QUICK = [
  { label: "Home", id: "home" }, { label: "About", id: "about" }, { label: "Events", id: "events" },
  { label: "Menus", id: "menus" }, { label: "Gallery", id: "gallery" }, { label: "Contact", id: "quote" },
];
const SERVICES = [
  { label: "Wedding Catering", msg: "Hi Momay Caterers, I'd like to know more about wedding catering." },
  { label: "Corporate Catering", msg: "Hi Momay Caterers, I'd like to know more about corporate catering." },
  { label: "Party Catering", msg: "Hi Momay Caterers, I'd like to know more about party catering." },
  { label: "Jain Catering", msg: "Hi Momay Caterers, I'd like to know more about Jain catering." },
  { label: "Live Counters", msg: "Hi Momay Caterers, I'd like to know more about live counters." },
  { label: "Private Events", msg: "Hi Momay Caterers, I'd like to know more about catering for private events." },
];

export const Footer = () => (
  <footer id="contact" data-testid="footer" className="bg-espresso grain relative border-t gold-hairline">
    <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-24 grid md:grid-cols-4 gap-12">
      <div>
        <span className="font-serif text-3xl tracking-[0.15em] text-cream">MOMAY</span>
        <span className="block text-[10px] tracking-[0.5em] text-gold mt-1">CATERERS</span>
        <p className="mt-5 font-script text-2xl text-gold">The taste you want.</p>
        <p className="mt-4 text-cream/50 text-sm font-light">25+ Years of Experience</p>
        <div className="mt-6 flex flex-wrap gap-3">
          <a data-testid="footer-call-btn" href={`tel:${PHONE_1_TEL}`} className="inline-flex items-center gap-2 border border-cream/25 text-cream px-4 py-2.5 text-[10px] tracking-[0.2em] uppercase hover:border-gold hover:text-gold transition-colors"><Phone size={13} /> Call Now</a>
          <a data-testid="footer-whatsapp-btn" href={waLink(WA_DEFAULT)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 border border-cream/25 text-cream px-4 py-2.5 text-[10px] tracking-[0.2em] uppercase hover:border-gold hover:text-gold transition-colors"><MessageCircle size={13} /> WhatsApp</a>
          <button data-testid="footer-quote-btn" onClick={() => scrollToId("quote")} className="inline-flex items-center gap-2 bg-gold text-espresso px-4 py-2.5 text-[10px] tracking-[0.2em] uppercase font-medium hover:bg-cream transition-colors">Get a Quote</button>
        </div>
      </div>

      <div>
        <h4 className="text-[10px] tracking-[0.35em] uppercase text-gold mb-6">Quick Links</h4>
        <ul className="space-y-3">
          {QUICK.map((q) => (
            <li key={q.id}>
              <button data-testid={`footer-link-${q.id}`} onClick={() => scrollToId(q.id)} className="text-cream/60 text-sm font-light hover:text-gold transition-colors">{q.label}</button>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="text-[10px] tracking-[0.35em] uppercase text-gold mb-6">Services</h4>
        <ul className="space-y-3">
          {SERVICES.map((s) => (
            <li key={s.label}>
              <a data-testid={`footer-service-${s.label.toLowerCase().replace(/\s+/g, "-")}`} href={waLink(s.msg)} target="_blank" rel="noopener noreferrer" className="text-cream/60 text-sm font-light hover:text-gold transition-colors">{s.label}</a>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="text-[10px] tracking-[0.35em] uppercase text-gold mb-6">Contact</h4>
        <ul className="space-y-4 text-sm font-light text-cream/60">
          <li><a data-testid="footer-phone-1" href={`tel:${PHONE_1_TEL}`} className="flex items-center gap-3 hover:text-gold transition-colors"><Phone size={15} className="text-gold shrink-0" /> {PHONE_1}</a></li>
          <li><a data-testid="footer-phone-2" href="tel:+918141961037" className="flex items-center gap-3 hover:text-gold transition-colors"><Phone size={15} className="text-gold shrink-0" /> {PHONE_2}</a></li>
          <li className="flex items-center gap-3"><MapPin size={15} className="text-gold shrink-0" /> Mandvi, Kutch, Gujarat</li>
          <li><a data-testid="footer-instagram" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-gold transition-colors"><Instagram size={15} className="text-gold shrink-0" /> {INSTAGRAM_HANDLE}</a></li>
        </ul>
      </div>
    </div>

    <div className="relative z-10 border-t gold-hairline">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[11px] tracking-[0.15em] uppercase text-cream/40">
        <span>© {new Date().getFullYear()} Momay Caterers. All rights reserved.</span>
        <span>Pure Vegetarian • Jain Food Available • Mandvi, Kutch</span>
      </div>
    </div>
  </footer>
);
